import { Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { CommunitySelector } from '@net3-multiplatform-client/libs';
import { UserService } from '../../../users/services/user.service';

@Component({
  selector: 'ccrr-list',
  imports: [CommunitySelector],
  templateUrl: './ccrr-list.html',
})
export class CcrrList implements OnInit {


  userService = inject(UserService);
  router = inject(Router);

  user: any;
  communities: any[] = [];

  async ngOnInit() {
    this.user = await this.userService.loadUserInfo();
    //console.log("USER: ", this.user);

    this.communities = this.user.memberships ?? [];
  }

}
